// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"826d1d9d","257":"c05ed4bb","416":"414bb3dc","687":"a7ee5391"}[chunkId] + ".chunk.css";
};